import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useTheme } from '@mui/material/styles';
import { Order } from '../../../../app/services/api/orderManagementClient';

interface SalesByStatusProps {
  orders: Order[];
}

const SalesByStatus = ({ orders }: SalesByStatusProps) => {
  const theme = useTheme();

  // Group sales by order status
  const statusTotals: { [status: string]: number } = {};
  orders.forEach(order => {
    statusTotals[order.status] = (statusTotals[order.status] || 0) + (order.totalCost || 0);
  });

  const data = Object.entries(statusTotals).map(([status, total]) => ({
    name: status,
    value: total,
  }));

  return (
    <ResponsiveContainer width="100%"
      height={200}>
      <BarChart data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3"
          stroke={theme.palette.divider} />
        <XAxis dataKey="name"
          stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <YAxis stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <Tooltip contentStyle={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.textSM.fontSize,
        }} />
        <Legend wrapperStyle={{
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.textSM.fontSize,
        }} />
        <Bar dataKey="value"
          fill={theme.palette.primary.main} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SalesByStatus;